export default store => (store ? store.state.user : null);



// WEBPACK FOOTER //
// ./src/child.js